import { render, staticRenderFns } from "./AppCloneBtn.vue?vue&type=template&id=4274b976&"
import script from "./AppCloneBtn.vue?vue&type=script&lang=js&"
export * from "./AppCloneBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports